module.exports = __webpack_public_path__ + "media/images/Sensibilisation-95722a6f59f7371fcdc1a2896eada2dc.svg";